import Swiper, { SwiperOverlayProps, SwiperProps } from 'canari-swipe'
import { Children, useContext } from 'react'
import { SIconProps, SViewProps } from '.'
import { ExplorerConfigContext } from '../providers/ExplorerConfigProvider'
import SIcon from './SIcon'
import SView from './SView'

export interface Props extends SwiperProps {}

export default function SCarousel({ children, ...rest }: Props) {
  const count = Children.count(children)
  return (
    <Swiper
      children={children}
      Overlay={p => <Overlay count={count} {...p} />}
      easingFunction="quad"
      {...rest}
    />
  )
}

function Overlay(props: SwiperOverlayProps & { count: number }) {
  const { actionClass, currentIndex, methods, count } = props
  const { theme } = useContext(ExplorerConfigContext)
  const progress = currentIndex / (count - 1)

  return (
    <SView position="absolute" zIndex={1} inset={0}>
      <SView h={35} />
      <SView flex={1} justify="space-between" direction="row">
        <SideButton
          disabled={progress === 0}
          className={actionClass}
          onClick={progress === 0 ? undefined : methods.prev}
          direction="left"
        />
        <SideButton
          direction="right"
          disabled={progress === 1}
          className={actionClass}
          onClick={progress === 1 ? undefined : methods.next}
        />
      </SView>
      <SView direction="row" h={35} justify="center" px={15} gap={7}>
        {Array.from({ length: count }).map((_, i) => (
          <SView
            backgroundColor={currentIndex === i ? theme.color.primary : '#FFFFFF33'}
            cursor={currentIndex === i ? 'default' : 'pointer'}
            borderRadius={10}
            className={actionClass}
            h={20}
            key={i}
            onClick={() => methods.goTo(i)}
            w={20}
          />
        ))}
      </SView>
    </SView>
  )
}

interface SideButtonProps extends Omit<SViewProps, 'children' | 'direction'> {
  direction: 'left' | 'right'
  disabled: boolean
  iconProps?: Omit<SIconProps, 'value'>
}

function SideButton({ direction, disabled, iconProps, ...rest }: SideButtonProps) {
  return (
    <SView
      cursor={disabled ? 'not-allowed' : 'pointer'}
      _hover={{ bg: disabled ? undefined : '#E5E5E511' }}
      {...(direction === 'left'
        ? { borderEndEndRadius: 100, borderStartEndRadius: 100 }
        : { borderEndStartRadius: 100, borderStartStartRadius: 100 })}
      align="center"
      justify="center"
      {...rest}
    >
      <SIcon
        color={disabled ? '#FFFFFF22' : '#FFFFFFBB'}
        fontSize={40}
        {...iconProps}
        value={direction === 'left' ? 'chevron-left' : 'chevron-right'}
      />
    </SView>
  )
}
